
import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route} from "react-router-dom"
import Home from "./Home";
import About from "./About";
import Projects from "./Projects";
import Contact from "./Contact";
require('dotenv').config();

function App() {
  return (
    <BrowserRouter>
    <div className="App">
        <Route exact path="/" component={Home} />
        <Route exact path="/About" component={About} />
        <Route exact path="/Projects" component={Projects} />
        <Route exact path="/Contact" component={Contact} />
    </div>
</BrowserRouter>

);
}

export default App;
